module.exports = "/_next/static/images/grow2-d14af6c43489ad8fc7ce91a4af2b358f.png";